import styled from 'styled-components';
import { media } from 'utils/detection';

export const Iframe = styled.iframe`
  height: 100%;
  width: 100%;
  object-fit: contain;
  border: none;
  background-size: cover;
`;

export const IFrameContainer = styled.div`
  position: relative;
  width: 100%;
  height: 25vh;
  background-size: cover;

  ${media.medium`
     height: 41vh;
  `};


  ${media.xxlarge`
     height: 54vh;
  `};
`;
